<template>
  <div class="item" id="cardInfo.id">
    <div class="title-box" v-on:click="tourl">
      <h3>{{title}}</h3>
    </div>
    <div class="item-list">
      <ul>
        <li v-for="item in itemList" v-bind:key="item.id" v-on:click="intourl(item)" class="itemli">
          <span class="textspan">{{item.title}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  export default {
    props: [
      'itemList',
      'title',
      'clickurl'
    ],
    methods: {
      intourl: function (item) {
        if (item.type === 1) {
          let paramer = {'categoryid': 43}
          this.$router.push({
            name: 'lectureroom',
            query: paramer
          })
        } else {
          let paramer = {menuidparent: item.menuidparent, menuidchild: item.menuidchild, voice: item.voice, mp4: 1, numbers: item.id}
          this.$router.push({
            name: 'videoplay',
            query: paramer
          })
        }
      },
      tourl: function () {
        if (typeof (this.clickurl) !== 'undefined') {
          this.$router.push(this.clickurl)
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  @import "../assets/style/mixin";

  .item {
    background-color: #FFFFFF;
    padding: 10px 10px 0 10px;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    text-align: center;
    margin:10px 10px 0 10px;
    .title-box{
      border: #838383 1px solid;
      border-radius: 20px;
      width: 100%;
      margin:10px 10px 10px 10px;
      padding:10px 10px 10px 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      h3{
        color: #7d7d7d;
        font-size: 19px;
      }
    }
    .item-list{
      margin:5px 10px 0 30px;
      padding:5px 10px 5px 30px;
      h3{
        padding:10px 10px 10px 10px;
        color: #838383;
        font-size: 18px;
      }
      li{
        color: #000000;
        text-align: left;
        list-style-type: square;
        cursor: pointer;
        line-height: 25px;
      }
    }
  }
  .itemli:hover .textspan{
    color: #3A5FCD;
  }
</style>



// WEBPACK FOOTER //
// specialtopic.vue?7d21c7d6